export default "__VITE_ASSET__BJE0MPAM__"